import {useSelector} from "react-redux";
import moment from "moment-timezone";


const buildCCI = (user) => {

    const CCI={}

    CCI.version = '1.2';

    CCI.unit = {
        type: {
            climb: 1, //vertical speed
            speed: 2,
            alt: 3,
            kmDist: 4, //distance expressed in km
            mDist: 5, //distance expressed in m
            taskDist: 6, //task distance, expressed in km to two digits
            temp: 7,
            date: 8, //dd/mm/yyyy or mm/dd/yyyy
            hmTime: 9, //hh:mm
            msTime: 10, //mm:ss
            hmsTime: 11, //hh:mm:ss expressed in milliseconds
            dateTime: 12, //hh:mm:ss. expressed in date millis
            speed2digits: 13, //speed expressed in two digits
            kmTaskDistRounded: 14, //km distance rounded down to floor
            kmDistRounded: 15, //km distance rounded
            mass: 16, //mass of the glider
            wingLoading: 17, //wing loading
            wingArea: 18, //wing area
            liquidVolume: 19, //liquid volume
            smallLiquidVolume: 20, //small liquid volume
            cgPosition: 21, //cgPosition
            fuelRate: 22, //fuelRate,
            climbPrecise: 23 //climb with two decimals
        },
        conversion: [
            [1, 1], //no value
            [1, 1.94384],// m/s to kts                                        climb:1,
            [1, 0.539957],// km/h to kts                                      speed:2,
            [1, 3.28084],// m to ft alt                                       alt:3,
            [1, 0.539957],// km to nautical miles                             kmDist:4,
            [1, 3.28084],// m to ft distance                                  mDist:5,
            [1, 1],// km task distance - always in km                         taskDist:6,
            [1, 1],// C temperature - conversion will override this value     temp:7,
            [1, 1],// conversion will override this value                     date:8,
            [1, 1],// conversion will override this value                     hTime:9,
            [1, 1],// conversion will override this value                     mTime:10,
            [1, 1],// conversion will override this value                     hmsTime:11,
            [1, 1],// conversion will override this value                     dateTime:12,
            [1, 0.539957],// km/h to kts                                      speed2digits:13,
            [1, 0.539957],// km to nautical miles                             kmDistRounded:14
            [1, 0.539957],// km to nautical miles                             kmDistRounded:15
            [1, 1 / 0.45359237],// kg to pounds                                 mass:16
            [1, 0.204816131],// km/m2 to lb/ft2                               wingLoading:17
            [1, 10.76391111],// m2 to ft2                                     wingArea:18
            [1, 0.264172052],// lt to Us Gal                                  liquid volume:19
            [1, 1.056688209],// lt to Us quarts                               small liquid volume:20
            [1, 0.0393701],// mm to inhces                                     cgPosition:21
            [1, 0.264172052],// lt/h to US Gal/h                                 fuelRate:22
            [1, 1.94384],// m/s to kts                                        climbPrecise:23,
        ],
        label: [
            ['', ''],
            ['m/s', 'kts'],    // climb:1,
            ['km/h', 'kts'],   // speed:2,
            ['m', 'ft'],       // alt:3,
            ['km', 'nm'],      // kmDist:4,
            ['m', 'ft'],       // mDist:5,
            ['km', 'km'],      // taskDist:6,
            ['C', 'F'],        // temp:7,
            ['', ''],          // date:8,
            ['', ''],          // hTime:9,
            ['', ''],          // mTime:10,
            ['', ''],          // hmsTime:11,
            ['', ''],          // dateTime:12,
            ['km/h', 'kts'],   // speed2digits:13,
            ['km', 'nm'],     // kmDistRounded:14
            ['km', 'nm'],      // kmDistRounded:15
            ['kg', 'lb'],      // mass:16
            ['kg/m<sup>2</sup>', 'lb/ft<sup>2</sup>'],      // wingLoading:17
            ['m<sup>2</sup>', 'ft<sup>2</sup>'],      // wingArea:18
            ['lt', 'US Gal'],      // liquid volume:19
            ['lt', 'Quarts'],      // small liquid volume:20
            ['mm', 'in'],      // cgPosition:21
            ['lt/h', 'US Gal/h'],      // fuelRate:22
            ['m/s', 'kts'],    // climbPrecise:23,
        ],
        formatting: [
            function (v, g) {
                return v
            },
            function (v, g) {
                return v.toFixed(1)
            },  // climb:1,
            function (v, g) {
                return Math.round(v)
            }, // speed:2,
            function (v, g) {
                return Math.round(v)
            }, // alt:3,
            function (v, g) {
                return v.toFixed(2)
            },  // kmDist:4,
            function (v, g) {
                return Math.round(v)
            }, // mDist:5,
            function (v, g) {
                return v.toFixed(2)
            },  // taskDist:6,
            function (v, g) {
                return v.toFixed(1)
            },  // temp:7,
            function (v, g) {
                return CCI.Util.toDateString(v)
            }, // date:8,
            function (v, g) {
                return CCI.Util.toHoursDurationString(v)
            }, // hmTime:9,
            function (v, g) {
                return CCI.Util.toMinDurationString(v)
            }, // msTime:10,
            function (v, g) {
                return CCI.Util.toHmsDurationString(v)
            }, // hmsTime:11,
            function (v, g) {
                return CCI.Util.toTimeString(v)
            }, // dateTime:12,
            function (v, g) {
                return v.toFixed(2)
            },  // speed2digits:13,
            function (v, g) {
                return Math.floor(v)
            },  // kmDistRounded:14,
            function (v, g) {
                return Math.round(v)
            },  // kmDistRounded:15
            function (v, g) {
                return Math.round(v)
            },  // mass:16
            function (v, g) {
                return !g ? Math.round(v * 100) / 100 : Math.round(v * 1000) / 1000
            },  // wingLoading:17
            function (v, g) {
                return !g ? Math.round(v * 10) / 10 : Math.round(v)
            },  // wingArea:18
            function (v, g) {
                return !g ? Math.round(v * 10) / 10 : Math.round(v * 100) / 100
            },  // liquid volume:19
            function (v, g) {
                return !g ? Math.round(v * 100) / 100 : Math.round(v * 10) / 10
            },  // small liquid volume:20
            function (v, g) {
                return !g ? Math.round(v) : Math.round(v * 100) / 100
            },  // cgPosition:21
            function (v, g) {
                return Math.round(v * 1000) / 1000
            },  // fuelRate:22
            function (v, g) {
                return v.toFixed(2)
            },  // climbPrecise:23,
        ],
        unitDefinition: [
            0,
            user.units.g,   // climb:1,
            user.units.g,   // speed:2,
            user.units.h !== undefined ? user.units.h : user.units.g,   // alt:3,
            user.units.g,   // kmDist:4,
            user.units.g,   // mDist:5,
            user.units.g,   // taskDist:6,
            user.units.g,   // temp:7,
            user.units.d,   // date:8,
            user.units.g,   // hTime:9,
            user.units.g,   // mTime:10,
            user.units.g,   // hmsTime:11,
            user.units.d,   // dateTime:12,
            user.units.g,   // speed2digits:13
            user.units.g,   // kmDistRounded:14
            user.units.g,   // kmDistRounded:15
            user.units.g,   // kmDistRounded:16
            user.units.g,   // wingLoading:17
            user.units.g,   // wingArea:18
            user.units.l !== undefined ? user.units.l : 0,  // liquid volume:19 //only use US Gal if user settings specifically dictate this
            user.units.l !== undefined ? user.units.l : 0,   // small liquid volume:20
            user.units.g,   // cgPosition:21
            user.units.l !== undefined ? user.units.l : 0,   // fuelRate:22
            user.units.g, //climbPrecise:23
        ]
    };

    CCI.Util = {
        /**Converts a value to the appropriate units and adds unit labels
         *
         * @param value
         * @param valueType - CCI.unit.type defines the type of value submitted
         * @param hideUnitLabel [optional] - do not add unit label
         * @param doNotSeparateLabel [optional] - do not add a space between value and units
         * @param unitType [optional] - by default units are taken from User preferences
         * @param noValueString [optional] overrides the undefined '-' character
         * @returns {string}
         */
        toUnitString: function (value, valueType, hideUnitLabel, doNotSeparateLabel, unitType, noValueString) {
            if (value === undefined) return noValueString !== undefined ? noValueString : '-';
            if (unitType === undefined) {
                unitType = CCI.unit.unitDefinition[valueType];
            }
            if (valueType === CCI.unit.type.temp && unitType === 1) {
                value = value * 9 / 5 + 32;
            }
            return CCI.unit.formatting[valueType](value * CCI.unit.conversion[valueType][unitType], unitType) +
                (doNotSeparateLabel || hideUnitLabel ? '' : ' ') +
                (hideUnitLabel ? '' : CCI.unit.label[valueType][unitType]);
        },
        /**Converts a value to the appropriate units and adds unit labels
         * formats the units
         *
         * @param value
         * @param valueType - CCI.unit.type defines the type of value submitted
         * @param doNotSeparateLabel [optional] - do not add a space between value and units
         * @param unitType [optional] - by default units are taken from User preferences
         * @param noValueString [optional] overrides the undefined '&nbsp;' character
         * @returns {string}
         */
        toUnitFormatedString: function (value, valueType, doNotSeparateLabel, unitType, noValueString, unitColor, unitSize) {
            unitColor = unitColor ? unitColor : '#666666';
            unitSize = unitSize ? unitSize : '8pt';
            if (value === undefined) return noValueString !== undefined ? noValueString : '&nbsp;';
            if (unitType === undefined) {
                unitType = CCI.unit.unitDefinition[valueType];
            }
            if (valueType == CCI.unit.type.temp && unitType == 1) {
                value = value * 9 / 5 + 32;
            }
            return CCI.unit.formatting[valueType](value * CCI.unit.conversion[valueType][unitType], unitType) +
                (doNotSeparateLabel ? '' : ' ') +
                '<span style="color:' + unitColor + ';font-size:' + unitSize + ';">' +
                CCI.unit.label[valueType][unitType] +
                '</span>';
        },
        /**Converts a value to the appropriate units and adds unit labels, returning the result as a json object
         *
         * @param value
         * @param valueType - CCI.unit.type defines the type of value submitted
         * @param unitType [optional] - by default units are taken from User preferences
         * @param noValueString [optional] overrides the undefined '-' character
         * @returns {v:formatedValue,l:unitLabel,y:<valueType>}
         */
        toUnitJsonString: function (value, valueType, unitType, noValueString) {
            if (value === undefined) return noValueString !== undefined ? noValueString : '-';
            if (unitType === undefined) {
                unitType = CCI.unit.unitDefinition[valueType];
            }
            if (valueType == CCI.unit.type.temp && unitType == 1) {
                value = value * 9 / 5 + 32;
            }
            return {
                v: CCI.unit.formatting[valueType](value * CCI.unit.conversion[valueType][unitType], unitType),
                l: CCI.unit.label[valueType][unitType],
                y: valueType
            };
        },
        /**Converts a value to the appropriate units and
         *
         * @param value
         * @param valueType - CCI.unit.type defines the type of value submitted
         * @param unitType [optional] - Type of unit the value is expressed in - by default units are taken from User preferences
         * @param ignoreFormating [optional] - if true will not attempty to format the value
         * @returns value in system units
         */
        toUnitValue: function (value, valueType, unitType, ignoreFormating) {
            if (value === undefined) return undefined;
            if (unitType === undefined) {
                unitType = CCI.unit.unitDefinition[valueType];
            }
            if (valueType == CCI.unit.type.temp && unitType == 1) {
                value = value * 9 / 5 + 32;
            }
            return ignoreFormating ? value * CCI.unit.conversion[valueType][unitType] : CCI.unit.formatting[valueType](value * CCI.unit.conversion[valueType][unitType], unitType);
        },
        /**Converts a user-supplied value to the system units
         *
         * @param value
         * @param valueType - CCI.unit.type defines the type of value submitted
         * @param unitType [optional] - Type of unit the value is expressed in - by default units are taken from User preferences
         * @returns value in system units
         */
        fromUnitValue: function (value, valueType, unitType) {
            if (value === undefined) return undefined;
            if (unitType === undefined) {
                unitType = CCI.unit.unitDefinition[valueType];
            }
            if (valueType == CCI.unit.type.temp && unitType == 1) {
                value = (value - 32) * 5 / 9;
            }
            return value / CCI.unit.conversion[valueType][unitType];
        },
        getUserUnits: function (valueType) {
            return CCI.unit.unitDefinition[valueType];
        },
        /**Returns the unit label for the value type
         *
         * @param valueType - CCI.unit.type defines the type of value submitted
         * @param unitType [optional] - Type of unit the value is expressed in - by default units are taken from User preferences
         */
        getUnitLabel: function (valueType, unitType) {
            if (unitType === undefined) {
                unitType = CCI.unit.unitDefinition[valueType];
            }
            return CCI.unit.label[valueType][unitType];
        },
        toTimeString: function (millis, allowOnlyMinSec, adjustToLocalTimezone) {
            var dte = new Date(millis);
            if (adjustToLocalTimezone) dte = new Date(millis - dte.getTimezoneOffset() * 60000);
            var hr = dte.getUTCHours();
            var mn = dte.getUTCMinutes();
            var sc = dte.getUTCSeconds();
            if (hr < 10) hr = '0' + hr;
            if (mn < 10) mn = '0' + mn;
            if (sc < 10) sc = '0' + sc;
            return (allowOnlyMinSec ? (hr > 0 ? hr + ":" : "") : hr + ":") + mn + ":" + sc;
        },
        toHoursString: function (millis) {
            var dte = new Date(millis);
            var negative = Number(millis) < 0
            if (negative) {
                dte = new Date(-millis);
                negative = true;
            }
            var hr = dte.getUTCHours();
            var mn = dte.getUTCMinutes();
            var sc = dte.getUTCSeconds();
            if (sc >= 30) mn++;
            if (mn < 10) mn = '0' + mn;
            return (negative ? "-" : "") + hr + ":" + mn;
        },
        toHoursDurationString: function (millis, zeroHours) {
            if (zeroHours === undefined) zeroHours = '-';
            if (millis == 0) return zeroHours;
            var hr = Math.floor(millis / 3600000);
            var mn = Math.round((millis - hr * 3600000) / 60000);
            if (mn < 10) mn = '0' + mn;
            return hr + ":" + mn;
        },
        toHmsDurationString: function (millis, zeroHours) {
            if (zeroHours === undefined) zeroHours = '-';
            if (millis == 0) return zeroHours;
            var hr = Math.floor(millis / 3600000);
            var mn = Math.floor((millis - hr * 3600000) / 60000);
            var sec = Math.round((millis - hr * 3600000 - mn * 60000) / 1000);
            if (mn < 10) mn = '0' + mn;
            if (sec < 10) sec = '0' + sec;
            return hr + ":" + mn + ":" + sec;
        },
        toMinDurationString: function (millis) {
            if (millis == 0) return '-';
            var min = Math.floor(millis / 60000);
            var sec = Math.round((millis - min * 60000) / 1000);
            if (sec < 10) sec = '0' + sec;
            return min + ":" + sec;
        },
        toDeltaDurationString: function (millis, zeroHours) {
            if (zeroHours === undefined) zeroHours = '-';
            if (millis == 0) return zeroHours;
            var hr = Math.floor(millis / 3600000);
            var mn = Math.floor((millis - hr * 3600000) / 60000);
            var sec = Math.round((millis - hr * 3600000 - mn * 60000) / 1000);
            if (mn < 10) mn = '0' + mn;
            if (sec < 10) sec = '0' + sec;
            return "+" + (hr > 0 ? hr + ":" : "") + mn + ":" + sec;
        },
        toTimeValue: function (str) {
            if (str === undefined || str.length == 0) return 0;
            var i = str.indexOf(':');
            if (i == -1) {
                return Number(str) * 3600000;
            }
            var h = Number(str.substring(0, i)) * 3600000;
            var j = str.length > i + 1 ? str.indexOf(':', i + 1) : -2;
            if (j == -2) return h;
            var m = 0;
            if (j == -1) {
                m = Number(str.substring(i + 1)) * 60000;
                return h + m;
            } else m = Number(str.substring(i + 1, j)) * 60000;
            if (str.length > j + 1) {
                var s = Number(str.substring(j + 1)) * 1000;
                return h + m + s
            } else return h + m;
        },
        toCoords: function (lat, lon, sep) {
            var c = '';

            if (sep === undefined) sep = "&nbsp;";


            c += lat < 0 ? "S " : "N ";
            var la = Math.abs(lat);
            var ld = Math.floor(la);
            var lm = (la - ld) * 60;
            var ls = Math.round((lm - Math.floor(lm)) * 6000) / 100;
            if (ld < 10) c += "0";
            c += ld + "&deg;";
            if (lm < 10) c += ("0");
            c += Math.floor(lm) + "'";
            if (ls < 10) c += "0";
            c += ls + '"';

            c += sep;

            c += lon < 0 ? " W " : " E ";
            c += Math.abs(lon) < 100.0 ? "0" : "";
            la = Math.abs(lon);
            ld = Math.floor(la);
            lm = (la - ld) * 60;
            ls = Math.round((lm - Math.floor(lm)) * 6000) / 100;
            if (ld < 10) c += "0";
            c += ld + "&deg;";
            if (lm < 10) c += "0";
            c += (Math.floor(lm) + "'");
            if (ls < 10) c += "0";
            c += ls + '"';

            return c;
        },
        toLat: function (lat) {
            var c = '';

            c += lat < 0 ? "S " : "N ";
            var la = Math.abs(lat);
            var ld = Math.floor(la);
            var lm = (la - ld) * 60;
            var ls = Math.round((lm - Math.floor(lm)) * 6000) / 100;
            if (ld < 10) c += "0";
            c += ld + "&deg;";
            if (lm < 10) c += ("0");
            c += Math.floor(lm) + "'";
            if (ls < 10) c += "0";
            c += ls + '"';
            return c;
        },
        toLon: function (lon) {
            var c = '';

            c += lon < 0 ? " W " : " E ";
            c += Math.abs(lon) < 100.0 ? "0" : "";
            let la = Math.abs(lon);
            let ld = Math.floor(la);
            let lm = (la - ld) * 60;
            let ls = Math.round((lm - Math.floor(lm)) * 6000) / 100;
            if (ld < 10) c += "0";
            c += ld + "&deg;";
            if (lm < 10) c += "0";
            c += (Math.floor(lm) + "'");
            if (ls < 10) c += "0";
            c += ls + '"';

            return c;
        },
        /**Parses a date dd/mm/yyyy is assumed
         *
         * format should be ddmmyyyy or yyyyddmm or mmddyyyy
         *
         * If for sume reason a number is passed instead of a string, the number is returned
         *
         * return millis
         */
        parseUtcDate: function (str, separator, format) {
            if (!isNaN(str)) return str;
            if (!separator) separator = "/";
            if (!format) format = "ddmmyyyy";
            var d = str.split(separator);
            if (d.length != 3) return;
            var date = 0;
            if (format == "yyyymmdd") date = new Date(Date.UTC(Number(d[0]), Number(d[1] - 1), Number(d[2])));
            else if (format == "mmddyyyy") date = new Date(Date.UTC(Number(d[2]), Number(d[0] - 1), Number(d[1])));
            else date = new Date(Date.UTC(Number(d[2]), Number(d[1] - 1), Number(d[0])));
            return date.getTime();
        },
        toDateString: function (millis, day, month, sep, usFormat, adjustToLocalTimezone) {

            var d = new Date(millis);

            var dt = d.getUTCDate();
            var mo = d.getUTCMonth() + 1;
            var yr = d.getUTCFullYear();
            var dy = '';

            if (adjustToLocalTimezone) {
                dt = d.getDate();
                mo = d.getMonth() + 1;
                yr = d.getFullYear();
            }

            if (sep === undefined) sep = '/';

            if (day == 'short') {
                dy = this.dayShort[d.getDay()] + ', ';
            } else if (day == 'abrev') { //day=abrev produces the following date format : Sun 01/12
                dy = this.dayShort[d.getDay()] + ' ';
                dt = (dt < 10 ? '0' : '') + dt;
            } else if (day == 'long') {
                dy = this.dayLong[d.getDay()] + ', ';
            } else {
                dt = (dt < 10 ? '0' : '') + dt;
            }

            if (month == 'short') {
                mo = this.monShort[mo - 1];
            } else if (month == 'long') {
                mo = this.monLong[mo - 1];
            } else {
                mo = (mo < 10 ? '0' : '') + mo;
            }

            if ((usFormat === undefined && user.units.d == 1) || usFormat) {
                return dy + mo + (month !== undefined ? ' ' : sep) + dt + (day !== undefined || month !== undefined ? ', ' : sep) + yr;
            } else {
                return dy + dt + ((day !== undefined && day != "abrev") || month !== undefined ? ' ' : sep) + mo + (day == 'abrev' ? '' : month !== undefined ? month == 'long' && day !== undefined ? ', ' : ' ' : sep) + (day != "abrev" ? yr : "");
            }
        },

        dayShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayLong: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        monShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        monLong: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

        toInputCoords: function (lat, lon, sep) {
            var c = '';

            if (sep === undefined) sep = " ";


            c += lat < 0 ? "S " : "N ";
            var la = Math.abs(lat);
            var ld = Math.floor(la);
            var lm = (la - ld) * 60;
            var ls = Math.round((lm - Math.floor(lm)) * 6000) / 100;
            if (ld < 10) c += "0";
            c += ld + " ";
            if (lm < 10) c += ("0");
            c += Math.floor(lm) + " ";
            if (ls < 10) c += "0";
            c += ls + ' ';

            c += sep;

            c += lon < 0 ? "W " : "E ";
            c += Math.abs(lon) < 100.0 ? "0" : "";
            la = Math.abs(lon);
            ld = Math.floor(la);
            lm = (la - ld) * 60;
            ls = Math.round((lm - Math.floor(lm)) * 6000) / 100;
            if (ld < 10) c += "0";
            c += ld + " ";
            if (lm < 10) c += "0";
            c += (Math.floor(lm) + " ");
            if (ls < 10) c += "0";
            c += ls + ' ';

            return c;
        },

        parseCoords: function (txt) {
            txt = txt.toUpperCase();

            var west = txt.indexOf('W') != -1;
            var south = txt.indexOf('S') != -1;

            txt = txt.replace(/\'/g, " ");
            txt = txt.replace(/\"/g, " ");
            txt = txt.replace(/�/g, " ");
            txt = txt.replace(/,/g, " ");
            txt = txt.replace('N', " ");
            txt = txt.replace('E', " ");
            txt = txt.replace('S', " ");
            txt = txt.replace('W', " ");
            txt = txt.replace(/\s{2,}/g, ' ');
            txt = txt.trim();

            let p = txt.split(" ");

            var t = [];
            var sneg = false;

            for (var i = 0; i < p.length; i++) {
                if (p[i] != '+' && p[i] != '-') {
                    if (sneg) {
                        t[t.length] = '-' + p[i];
                    } else {
                        t[t.length] = p[i];
                    }
                    sneg = false;
                } else {
                    if (p[i] != '-') sneg = true;
                }
            }

            var lat = Number.NaN;
            var lon = Number.NaN;

            if (t.length == 2) {
                lat = Number(t[0]);
                lon = Number(t[1]);

            } else if (t.length == 4) {
                lat = Number(t[0]) + Number(t[1]) / 60.00;
                lon = Number(t[2]) + Number(t[3]) / 60.00;
            } else if (t.length == 6) {
                lat = Number(t[0]) + Number(t[1]) / 60.00 + Number(t[2]) / 3600.00;
                lon = Number(t[3]) + Number(t[4]) / 60.00 + Number(t[5]) / 3600.00;
            }

            if (west) {
                lon = -lon;
            }
            if (south) {
                lat = -lat;
            }

            if (Math.abs(lat) > 90) lat = Number.NaN;
            if (Math.abs(lon) > 180) lon = Number.NaN;

            if (isNaN(lat) || isNaN(lon)) return undefined;

            var ret = {};

            ret.lat = lat;
            ret.lon = lon;

            return ret;
        },

        isNumber: function (txt) {
            return !isNaN(parseFloat(txt)) && isFinite(txt);
        },


        getAlphaCode: function () {
            if (CCI.ac === undefined) CCI.ac = CCI.alphaCodes();
            return CCI.ac.getCode();
        },
        toProperCase: function (txt) {
            return txt.toLowerCase().replace(/^(.)|\s(.)/g, function (tt) {
                return tt.toUpperCase();
            });
        },
        toCommaDelimitedNumber: function (x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        },
        toFt: function (m) {
            return Math.round(m * 3.28084);
        },
        toMeters: function (ft) {
            return Math.round(ft / 3.28084);
        },
        toNm: function (km, decimals) {
            var nm = km / 1.852;
            return nm.toFixed(decimals ? decimals : 0);
        },
        toPeriodDescription: function (period) {
            if (period.tpa) return "All";
            if (period.tpr) {
                if (period.tpr == 'a') return "2 years";
                if (period.tpr == 'e') return "1 year";
                if (period.tpr == 'q') return "90 days";
                if (period.tpr == 'm') return "30 days";
                if (period.tpr == 'w') return "7 days";
                if (period.tpr == 't') return "Today";
                if (period.tpr == 'z') return "Latest season";
                if (period.tpr == 'd') return "Latest day";
            }
            if (period.tps) return period.tps + ' Season';
            if (period.tpy) return period.tpy;
            if (period.tpf && period.tpt) {
                var format = user.units.d ? "MM/DD/YYYY" : "DD/MM/YYYY";
                return moment(period.tpf, "YYYYMMDD").format(format) + ' - ' + moment(period.tpt, "YYYYMMDD").format(format);
            }
            if (period.tpf) {
                var format = user.units.d ? "MM/DD/YYYY" : "DD/MM/YYYY";
                return 'from ' + moment(period.tpf, "YYYYMMDD").format(format);
            }
            if (period.tpt) {
                var format = user.units.d ? "MM/DD/YYYY" : "DD/MM/YYYY";
                return 'to ' + moment(period.tpt, "YYYYMMDD").format(format);
            }
            return 'Undefined';
        },
        getNameCode: function () {
            var codes = CCI.markerCodes;
            var count = CCI.markerCount++;
            var code = codes[count % codes.length];
            var i = Math.floor(count / codes.length);
            if (i > 0) code = code + i;
            return code;
        },
        shuffle: function (o) {
            for (var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x) ;
            return o;
        }
    }

    CCI.markerCodes = CCI.Util.shuffle(['ALPHA', 'BRAVO', 'CHARLIE', 'DELTA', 'ECHO', 'FOXTROT', 'GOLF', 'HOTEL', 'INDIA', 'JULIET', 'KILO', 'LIMA', 'MIKE', 'NOVEMBER', 'OSCAR', 'PAPA', 'QUEBEC', 'ROMEO', 'SIERRA', 'TANGO', 'UNIFORM', 'VICTOR', 'WHISKEY', 'X-RAY', 'YANKEE', 'ZULU']);
    CCI.markerCount = 0;

    return CCI
}

export const useCCI = () => {
    const user = useSelector( state => state.session.user)

    return buildCCI(user)
}